import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Media from '@components/atoms/Media';
import Title from '@components/atoms/Title';
import Link from '@components/atoms/Link';
import Price from '@components/atoms/Price';
import Badge from '@components/atoms/Badge';
import { dataLayerClick } from '@helpers/dataLayerPush';
import BVInline from '@components/molecules/BVInline';

const ProductCardBody = ({ productData, isClickable = false }) => {
  const { slug, title, price, images, productClassification } = productData;
  const mediaFile = images.length > 0 ? images[0] : null;

  return (
    <Flex
      direction="column"
      height="100%"
      maxHeight="23.313rem"
      boxShadow="md"
      p="1rem"
      rounded="md"
      bg="white">
      <Media
        media={mediaFile}
        height="auto"
        imgStyle={{
          objectFit: `contain`
        }}
      />
      <Box mt="auto">
        {productClassification?.badgeText &&
          productClassification.badgeText.length > 0 && (
            <Badge text={productClassification.badgeText} />
          )}
        <Title
          as="h4"
          pt="0.625rem"
          fontSize={{ base: `xs`, md: `md` }}
          fontWeight="600">
          {isClickable ? (
            <Box as="span" color="purple.600">
              {title}
            </Box>
          ) : (
            <Link
              href={slug}
              color="purple.600"
              onClick={() => {
                dataLayerClick({
                  event: `cta_click`,
                  clickText: title,
                  clickUrl: slug
                });
              }}>
              {title}
            </Link>
          )}
        </Title>
        <Price value={price} />
        <BVInline productSlug={productData?.slug} small />
      </Box>
    </Flex>
  );
};

export default ProductCardBody;
